export const OFFER_PLAN_KEYS = {
  literacy: 35,
  agentic: 33,
  professionals: 33,
} as const;

export type OfferPlanKey = keyof typeof OFFER_PLAN_KEYS;

export function isOfferPlanKey(value: string | null): value is OfferPlanKey {
  return value != null && value in OFFER_PLAN_KEYS;
}

const OFFER_KEY_BY_CATALOG_SLUG: Record<string, OfferPlanKey> = {
  "ai-essentials": "literacy",
  "agentic-ai": "agentic",
};

export function offerPlanKeyForCatalogSlug(slug: string): OfferPlanKey | null {
  return OFFER_KEY_BY_CATALOG_SLUG[slug] ?? null;
}
